import type { EnumValue } from '../utils';

import type { Member } from './member';
import type { VpnRegionsList } from './regions';
import type { ConnectionStatus } from './status';

export const OS_NAMES = {
    LINUX: 'LINUX',
    MACOS: 'MACOS',
    WINDOWS: 'WINDOWS',
    ANDROID: 'ANDROID',
    IOS: 'IOS',
    ChromeOS: 'CHROMEOS',
    UNKNOWN: 'UNKNOWN',
    EMPTY: 'EMPTY',
} as const;

export type OSNameValue = (typeof OS_NAMES)[keyof typeof OS_NAMES];

export const OS_NAME_MAPPINGS = {
    [OS_NAMES.ANDROID]: 'Android',
    [OS_NAMES.IOS]: 'iOS',
    [OS_NAMES.LINUX]: 'Linux',
    [OS_NAMES.MACOS]: 'macOS',
    [OS_NAMES.WINDOWS]: 'Windows',
    [OS_NAMES.ChromeOS]: 'ChromeOS',
    [OS_NAMES.UNKNOWN]: 'Other OS',
    [OS_NAMES.EMPTY]: 'Empty',
} as const;

export type DevicePlatform = {
    osType?: EnumValue<typeof OS_NAMES>;
    osVersion?: string;
};

export type Device = {
    id: string;
    name: string;
    description?: string;
    applicationId?: string;
    platform?: DevicePlatform;
    ipV4Address: string;
    ipV6Address: string;

    connectedTo?: string;
    connectionStatus: ConnectionStatus;

    vpnRegions: VpnRegionsList;
    group: Member['group'];
    user: Omit<Member, 'group' | 'temporaryPassword' | 'connectionStatus'>;
};
